module.exports = new __parcel__URL__("Wmbf.a64c4fd7.webp").toString();